import { FC, memo } from 'react';
import { ReceiptFilterForm, IReceiptFilterForm } from './ReceiptFilterForm';

const ReceiptFilter: FC<IReceiptFilterForm> = memo((props) => <ReceiptFilterForm {...props} />);

export { ReceiptFilter };
